export const MAPBOX_TOKEN = import.meta.env.VITE_MAPBOX_TOKEN;

export const MAP_STYLES = [
  { id: "landhep-simple-day",    label: "Landhep Day",    color: "#f4f1ec", local: true },
  { id: "streets-v12",           label: "Streets",        color: "#e8e0d8" },
  { id: "light-v11",             label: "Monochrome",     color: "#f5f5f0" },
  { id: "navigation-day-v1",     label: "Day Traffic",    color: "#e8d5a3" },
  { id: "navigation-night-v1",   label: "Night Traffic",  color: "#0d1b2a" },
];

export function styleUrl(idOrUrl) {
  // Already a full URL (mapbox:// or http/https) — pass through
  if (!idOrUrl || idOrUrl.startsWith("mapbox://") || idOrUrl.startsWith("http")) return idOrUrl || "mapbox://styles/mapbox/streets-v12";
  // Look up in MAP_STYLES to check if it's a local style
  const entry = MAP_STYLES.find((s) => s.id === idOrUrl);
  if (entry?.local) return `${import.meta.env.VITE_API_URL || ""}/static/data/basemap/${idOrUrl}.json`;
  return `mapbox://styles/mapbox/${idOrUrl}`;
}
